export default "__VITE_ASSET__ashvvGcJ__"